import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setVendorAddressAction,
  setVendorAddressesStatusAction,
  setVendorAddressesErrorsAction,
  clearVendorAddressesErrorsAction
} from './vendorAddresses.actions'

export const editVendorAddress = (id, formData) => async dispatch => {
  try {
    dispatch(setVendorAddressesStatusAction('loading'))
    dispatch(clearVendorAddressesErrorsAction())

    const { data } = await branditRails.patch(`/vendor_addresses/${id}`, formData)

    dispatch(setVendorAddressAction(data))
    dispatch(setVendorAddressesStatusAction('succeeded'))
    toastr.success('Success', 'Vendor address updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setVendorAddressesErrorsAction({ message: errorMessage }))
    dispatch(setVendorAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
